// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: knowledege_graph.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  AggregationType,
  aggregationTypeFromJSON,
  aggregationTypeToJSON,
  BenchmarkType,
  benchmarkTypeFromJSON,
  benchmarkTypeToJSON,
  ColumnType,
  columnTypeFromJSON,
  columnTypeToJSON,
  TimeBucket,
  timeBucketFromJSON,
  timeBucketToJSON,
} from "./enums";
import { FilterProto, FormatProto, Header, ObservationProto } from "./metadata";
import { DatePeriodEnum, datePeriodEnumFromJSON, datePeriodEnumToJSON, GrowthBenchmarkProto } from "./relative_date";

export const protobufPackage = "com.meritic.newton";

/** Proto representation of KGColumn. */
export interface KGColumnProto {
  /** Header of the kg column. */
  header?:
    | Header
    | undefined;
  /** KGColumn type. */
  column_type?:
    | ColumnType
    | undefined;
  /** Default aggregation in case of measure KG column. */
  aggregation?:
    | AggregationType
    | undefined;
  /** Default bucketing in case of measure KG column. */
  time_bucket?:
    | TimeBucket
    | undefined;
  /** Cardinality of KG column. */
  cardinality?:
    | number
    | undefined;
  /** Map of model id to logical column. */
  logical_columns: Header[];
  /** formatting of kg column. */
  formatting?: FormatProto | undefined;
}

/** Proto representation of Benchmark entity. */
export interface BenchmarkEntityProto {
  /** Header of the benchmark. */
  header?:
    | Header
    | undefined;
  /** Benchmark type. */
  benchmark_type?:
    | BenchmarkType
    | undefined;
  /** Granularity in case of target benchmark. */
  granularity?:
    | DatePeriodEnum
    | undefined;
  /**
   * One of the following should be set based on the type of benchmark.
   * Map of model id to logical column.
   */
  definition_mapping: BenchmarkEntityProto_DefinitionMapping[];
  /** Growth benchmark. */
  growth_benchmark?:
    | GrowthBenchmarkProto
    | undefined;
  /** Filter in case of VsBenchmark like compare with pillar = OE Jr. */
  versus_filters: FilterProto[];
}

export interface BenchmarkEntityProto_DefinitionMapping {
  /** Metric id. */
  metric_id?:
    | string
    | undefined;
  /** Benchmark definition. */
  benchmark_definition?: ObservationProto | undefined;
}

function createBaseKGColumnProto(): KGColumnProto {
  return {
    header: undefined,
    column_type: undefined,
    aggregation: undefined,
    time_bucket: undefined,
    cardinality: undefined,
    logical_columns: [],
    formatting: undefined,
  };
}

export const KGColumnProto: MessageFns<KGColumnProto> = {
  encode(message: KGColumnProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.column_type !== undefined) {
      writer.uint32(16).int32(message.column_type);
    }
    if (message.aggregation !== undefined) {
      writer.uint32(24).int32(message.aggregation);
    }
    if (message.time_bucket !== undefined) {
      writer.uint32(32).int32(message.time_bucket);
    }
    if (message.cardinality !== undefined) {
      writer.uint32(40).int32(message.cardinality);
    }
    for (const v of message.logical_columns) {
      Header.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.formatting !== undefined) {
      FormatProto.encode(message.formatting, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KGColumnProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKGColumnProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.column_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.aggregation = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.time_bucket = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.cardinality = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.logical_columns.push(Header.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.formatting = FormatProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KGColumnProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      column_type: isSet(object.column_type) ? columnTypeFromJSON(object.column_type) : undefined,
      aggregation: isSet(object.aggregation) ? aggregationTypeFromJSON(object.aggregation) : undefined,
      time_bucket: isSet(object.time_bucket) ? timeBucketFromJSON(object.time_bucket) : undefined,
      cardinality: isSet(object.cardinality) ? globalThis.Number(object.cardinality) : undefined,
      logical_columns: globalThis.Array.isArray(object?.logical_columns)
        ? object.logical_columns.map((e: any) => Header.fromJSON(e))
        : [],
      formatting: isSet(object.formatting) ? FormatProto.fromJSON(object.formatting) : undefined,
    };
  },

  toJSON(message: KGColumnProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.column_type !== undefined) {
      obj.column_type = columnTypeToJSON(message.column_type);
    }
    if (message.aggregation !== undefined) {
      obj.aggregation = aggregationTypeToJSON(message.aggregation);
    }
    if (message.time_bucket !== undefined) {
      obj.time_bucket = timeBucketToJSON(message.time_bucket);
    }
    if (message.cardinality !== undefined) {
      obj.cardinality = Math.round(message.cardinality);
    }
    if (message.logical_columns?.length) {
      obj.logical_columns = message.logical_columns.map((e) => Header.toJSON(e));
    }
    if (message.formatting !== undefined) {
      obj.formatting = FormatProto.toJSON(message.formatting);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KGColumnProto>, I>>(base?: I): KGColumnProto {
    return KGColumnProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KGColumnProto>, I>>(object: I): KGColumnProto {
    const message = createBaseKGColumnProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.column_type = object.column_type ?? undefined;
    message.aggregation = object.aggregation ?? undefined;
    message.time_bucket = object.time_bucket ?? undefined;
    message.cardinality = object.cardinality ?? undefined;
    message.logical_columns = object.logical_columns?.map((e) => Header.fromPartial(e)) || [];
    message.formatting = (object.formatting !== undefined && object.formatting !== null)
      ? FormatProto.fromPartial(object.formatting)
      : undefined;
    return message;
  },
};

function createBaseBenchmarkEntityProto(): BenchmarkEntityProto {
  return {
    header: undefined,
    benchmark_type: undefined,
    granularity: undefined,
    definition_mapping: [],
    growth_benchmark: undefined,
    versus_filters: [],
  };
}

export const BenchmarkEntityProto: MessageFns<BenchmarkEntityProto> = {
  encode(message: BenchmarkEntityProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.benchmark_type !== undefined) {
      writer.uint32(16).int32(message.benchmark_type);
    }
    if (message.granularity !== undefined) {
      writer.uint32(24).int32(message.granularity);
    }
    for (const v of message.definition_mapping) {
      BenchmarkEntityProto_DefinitionMapping.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.growth_benchmark !== undefined) {
      GrowthBenchmarkProto.encode(message.growth_benchmark, writer.uint32(42).fork()).join();
    }
    for (const v of message.versus_filters) {
      FilterProto.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BenchmarkEntityProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBenchmarkEntityProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.benchmark_type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.granularity = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.definition_mapping.push(BenchmarkEntityProto_DefinitionMapping.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.growth_benchmark = GrowthBenchmarkProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.versus_filters.push(FilterProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BenchmarkEntityProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      benchmark_type: isSet(object.benchmark_type) ? benchmarkTypeFromJSON(object.benchmark_type) : undefined,
      granularity: isSet(object.granularity) ? datePeriodEnumFromJSON(object.granularity) : undefined,
      definition_mapping: globalThis.Array.isArray(object?.definition_mapping)
        ? object.definition_mapping.map((e: any) => BenchmarkEntityProto_DefinitionMapping.fromJSON(e))
        : [],
      growth_benchmark: isSet(object.growth_benchmark)
        ? GrowthBenchmarkProto.fromJSON(object.growth_benchmark)
        : undefined,
      versus_filters: globalThis.Array.isArray(object?.versus_filters)
        ? object.versus_filters.map((e: any) => FilterProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BenchmarkEntityProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.benchmark_type !== undefined) {
      obj.benchmark_type = benchmarkTypeToJSON(message.benchmark_type);
    }
    if (message.granularity !== undefined) {
      obj.granularity = datePeriodEnumToJSON(message.granularity);
    }
    if (message.definition_mapping?.length) {
      obj.definition_mapping = message.definition_mapping.map((e) => BenchmarkEntityProto_DefinitionMapping.toJSON(e));
    }
    if (message.growth_benchmark !== undefined) {
      obj.growth_benchmark = GrowthBenchmarkProto.toJSON(message.growth_benchmark);
    }
    if (message.versus_filters?.length) {
      obj.versus_filters = message.versus_filters.map((e) => FilterProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BenchmarkEntityProto>, I>>(base?: I): BenchmarkEntityProto {
    return BenchmarkEntityProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BenchmarkEntityProto>, I>>(object: I): BenchmarkEntityProto {
    const message = createBaseBenchmarkEntityProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.benchmark_type = object.benchmark_type ?? undefined;
    message.granularity = object.granularity ?? undefined;
    message.definition_mapping =
      object.definition_mapping?.map((e) => BenchmarkEntityProto_DefinitionMapping.fromPartial(e)) || [];
    message.growth_benchmark = (object.growth_benchmark !== undefined && object.growth_benchmark !== null)
      ? GrowthBenchmarkProto.fromPartial(object.growth_benchmark)
      : undefined;
    message.versus_filters = object.versus_filters?.map((e) => FilterProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBenchmarkEntityProto_DefinitionMapping(): BenchmarkEntityProto_DefinitionMapping {
  return { metric_id: undefined, benchmark_definition: undefined };
}

export const BenchmarkEntityProto_DefinitionMapping: MessageFns<BenchmarkEntityProto_DefinitionMapping> = {
  encode(message: BenchmarkEntityProto_DefinitionMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metric_id !== undefined) {
      writer.uint32(10).string(message.metric_id);
    }
    if (message.benchmark_definition !== undefined) {
      ObservationProto.encode(message.benchmark_definition, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BenchmarkEntityProto_DefinitionMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBenchmarkEntityProto_DefinitionMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metric_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.benchmark_definition = ObservationProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BenchmarkEntityProto_DefinitionMapping {
    return {
      metric_id: isSet(object.metric_id) ? globalThis.String(object.metric_id) : undefined,
      benchmark_definition: isSet(object.benchmark_definition)
        ? ObservationProto.fromJSON(object.benchmark_definition)
        : undefined,
    };
  },

  toJSON(message: BenchmarkEntityProto_DefinitionMapping): unknown {
    const obj: any = {};
    if (message.metric_id !== undefined) {
      obj.metric_id = message.metric_id;
    }
    if (message.benchmark_definition !== undefined) {
      obj.benchmark_definition = ObservationProto.toJSON(message.benchmark_definition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BenchmarkEntityProto_DefinitionMapping>, I>>(
    base?: I,
  ): BenchmarkEntityProto_DefinitionMapping {
    return BenchmarkEntityProto_DefinitionMapping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BenchmarkEntityProto_DefinitionMapping>, I>>(
    object: I,
  ): BenchmarkEntityProto_DefinitionMapping {
    const message = createBaseBenchmarkEntityProto_DefinitionMapping();
    message.metric_id = object.metric_id ?? undefined;
    message.benchmark_definition = (object.benchmark_definition !== undefined && object.benchmark_definition !== null)
      ? ObservationProto.fromPartial(object.benchmark_definition)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
